import RegistryVisibility from './registry-visibility'

export default RegistryVisibility
